"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isResponse(message) {
  return 'id' in message && 'result' in message;
}

exports.isResponse = isResponse;

function isNotification(message) {
  return !('id' in message);
}

exports.isNotification = isNotification;

function isRequest(message) {
  return 'id' in message && 'params' in message;
}

exports.isRequest = isRequest;

function isError(message) {
  return 'id' in message && 'error' in message;
}

exports.isError = isError;